import React from 'react';
import { AuroraRoot, Inset } from '@aurora/widgets-react';

import Navigation from './Navigation';
import Pages from './Pages';

import './app.css';

const App = () => {
  return (
    <AuroraRoot>
      <div className="appContainer">
        <div className="mainContainer">
          <Navigation />
          <div className="mainContent">
            <Inset size="xxl" className="pageContainer">
              <Pages />
            </Inset>
          </div>
        </div>
      </div>
    </AuroraRoot>
  );
};

export default App;
